const data = [
  {
    title: 'Frontend',
    items: ['ReactJS (context, hooks)', 'Redux'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Backends & Servers',
    items: ['NodeJS', 'Express', 'Koa', 'Python', 'Django'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Database',
    items: ['MongoDB', 'Firebase RealtimeDB', 'Firebase CloudStore', 'MySQL'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'UI Frameworks/ Design System',
    items: ['Material UI', 'Bootstrap 4'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Deployment & CI CD',
    items: [
      'Docker',
      'K8s',
      'Jenkins',
      'Amazon S3 Buckets',
      'Travis',
      'Circle CI'
    ],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Web Hosting',
    items: ['Firebase Hosting', 'Heroku', 'Github Pages', 'Amazon'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Unit Testing',
    items: ['Jest', 'Enzyme'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Mobile',
    items: [
      'React Native',
      'Expo',
      'Kotlin',
      'Android Studio',
      'XCode',
      'Swift'
    ],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Code Revisioning',
    items: ['Git', 'Github Desktop', 'Source Tree'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Design & Mockup',
    items: [
      'Balsamiq',
      'Moqup',
      'Pencil',
      'Adobe Photoshop',
      'Adobe Illustrator'
    ],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Issue Tracking',
    items: ['JIRA', 'BugZilla'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Vizualisation & Graphs',
    items: ['Google Charts', 'HighCharts', 'D3JS'],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Misc',
    items: [
      'Git',
      'VS Code Extensions',
      'Google Chrome Extensions',
      'NVM',
      'Indexed DB',
      'Service Workers'
    ],
    icon: null,
    imgAltText: ''
  },
  {
    title: 'Other SPAs',
    items: [
      'VueJS',
      'VueX',
      'AngularJS',
      'DurandalJS',
      'KnockoutJS',
      'BackboneJS'
    ],
    icon: null,
    imgAltText: ''
  }
];

export default data;
